import Modal from 'react-bootstrap/Modal';

const ModalTemplate = ({
    show,
    closeFun,
    size,
    centered,
    title,
    body,
    footer,
    is_custom,
    backdrop = "static",
    keyboard = true,
    isRemoveBodyPadding = false
}) => {
    return (
        <Modal 
            show={show} 
            onHide={closeFun}
            centered = {centered}
            size={size}
            backdrop = {backdrop}
            keyboard = {keyboard}
        >
            {title != null && (
                <Modal.Header closeButton = {closeFun != null}>
                    {is_custom ? title : <Modal.Title>{title}</Modal.Title>}
                </Modal.Header>
            )} 

            <Modal.Body className={isRemoveBodyPadding ? 'p-0 rounded-2' : ''}>
                {body}
            </Modal.Body>

            {footer != null && (
                <Modal.Footer>
                    {footer}
                </Modal.Footer>  
            )} 
        </Modal>
    );
}

export default ModalTemplate;